import {
  StyledAppBar,
  StyledBox,
  StyledDiv,
  StyledDivider,
  StyledImage,
  StyledLogoImage,
  StyledSuperContainer,
  StyledToolBar
} from './HeaderStyles'
import ProfileCircle from '../Common/ProfileCircle/ProfileCircle'
import deloitteLogo from '../../icons/deloitte-logo-white.svg'
import {useDispatch, useSelector} from 'react-redux'
import {useEffect, useState} from 'react'
import SuperUserIndex from '../SuperUser/SuperUserIndex'
import {setSuperUser} from '../../store/superuser/superUserSlice'
import gpLogo from '../../icons/GP_Logo_Login_TM.svg'

const HeaderIndex = () => {
  const userRoles = useSelector((state) => state.userProfile.userRoles)
  const [isSuperUser, setIsSuperUser] = useState(false)
  const azureRole = useSelector((state) => state.superUserTenantSlice.azureRole)
  const dispatch = useDispatch()
  const [currentLogo, setCurrentLogo] = useState(gpLogo)
  useEffect(() => {
    if (userRoles && userRoles.length > 0) {
      setIsSuperUser(userRoles.includes('SuperUser'))
    }
  }, [userRoles, dispatch])

  useEffect(() => {
    if (isSuperUser) dispatch(setSuperUser(isSuperUser))
  }, [isSuperUser, dispatch])

  useEffect(() => {
    const loadLogoBasedOnRole = async () => {
      // Always use default GP logo if userRoles is undefined, null, or empty
      if (!userRoles || userRoles.length === 0) {
        setCurrentLogo(gpLogo)
        return
      }
      if (userRoles.length > 0 && !isSuperUser) {
        for (const role of userRoles) {
          try {
            const underscoreIndex = role.indexOf('_')
            const roleName =
              underscoreIndex === -1 ? role.toLowerCase() : role.substring(0, underscoreIndex).toLowerCase()
            // Try to dynamically import the logo based on azureRole
            const roleBasedLogo = await import(`../../../public/${roleName}_Logo.svg`)
            setCurrentLogo(roleBasedLogo.default)
            return
          } catch {
            // Try next role if logo not found
            console.warn(`Logo not found for role ${role}`)
          }
        }
        // If no role-based logo found, use default GP logo
        console.warn(`Logo not found for all roles, using default GP logo`)
        setCurrentLogo(gpLogo)
      } else {
        // If superuser Role, use default GP logo
        setCurrentLogo(gpLogo)
      }
    }

    loadLogoBasedOnRole()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [azureRole, userRoles])

  return (
    <StyledAppBar position="fixed">
      <StyledToolBar>
        <StyledBox flexGrow={1}>
          <StyledDiv>
            <StyledImage src={deloitteLogo} alt="Deloitte Logo" />
            <StyledDivider orientation="vertical" flexItem />
            <StyledLogoImage src={currentLogo} alt="Logo" />
          </StyledDiv>
          {isSuperUser && (
            <StyledSuperContainer data-testid="superuser-container">
              <SuperUserIndex />
            </StyledSuperContainer>
          )}
          <ProfileCircle placement={'right'} welcomeMessage={true} />
        </StyledBox>
      </StyledToolBar>
    </StyledAppBar>
  )
}
export default HeaderIndex
